<app-deprecated-confirmation-dialog
    #deleteConfirmationDialog
    [description]="'performance.feedback-show.deleteConfirmationDialog.description'"
    [label]="'performance.feedback-show.deleteConfirmationDialog.label'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic narrow segment" [class.loading]="isLoading" *ngIf="feedback">
    <div class="floated right">
        <ui-badge class="margin-left-1" [type]="BADGE_TYPES[feedback.visibility]">{{
            feedbackVisibility | translate
        }}</ui-badge>

        <ui-badge *ngIf="feedback.positive" type="success">{{ feedbackTypes.positive | translate }}</ui-badge>
        <ui-badge *ngIf="feedback.constructive" type="warning">{{ feedbackTypes.constructive | translate }}</ui-badge>
        <ui-badge *ngIf="feedback.negative" type="danger">{{ feedbackTypes.negative | translate }}</ui-badge>
    </div>

    <app-header [title]="feedback.title" [back]="true" [contextMenu]="true" contextMenuType="material">
        <button *ngIf="canDelete()" mat-menu-item (click)="delete()">
            {{ 'performance.feedback-show.deleteLabel' | translate }}
        </button>
    </app-header>

    <div class="ui clear hidden double divider"></div>

    <div class="ui segment">
        <p
            *ngIf="feedback.visibility === 'public'"
            [innerHtml]="'performance.feedback-show.publicDescription' | translate"
        ></p>
        <p
            *ngIf="feedback.visibility === 'private'"
            [innerHtml]="'performance.feedback-show.privateDescription' | translate"
        ></p>
        <p
            *ngIf="feedback.visibility === 'manager'"
            [innerHtml]="'performance.feedback-show.managerDescription' | translate"
        ></p>
        <p
            *ngIf="feedback.visibility === 'admin'"
            [innerHtml]="'performance.feedback-show.adminDescription' | translate"
        ></p>

        <div class="ui divider"></div>

        <app-avatar *ngIf="feedback.creator" [employee]="feedback.creator" [name]="true"></app-avatar>

        <p style="float: right">{{ feedback.createdAt | appDate: 'mediumDate' }}</p>

        <br />
        <br />

        <p class="quill" [innerHtml]="getFeedbackBody() | sanitizeHtml"></p>

        <br />
        <br />
    </div>

    <ng-template [ngIf]="feedback.badge">
        <div class="ui clear hidden double divider"></div>

        <h2 class="ui left floated header">{{ 'performance.feedback-show.badges' | translate }}</h2>
        <div class="ui clear hidden divider"></div>

        <div class="ui segment">
            <p [innerHtml]="'performance.feedback-show.badgesDescription' | translate"></p>

            <div class="badge-holder">
                <profile-badge [badge]="feedback.badge"></profile-badge>
                <div class="clear"></div>
            </div>
        </div>
    </ng-template>
</div>
